var allCompanyLists = function () {

    function pageBodyLoad() {
        checkUserStatus();
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            companyLists.getRecentCompanyLists();
        }
        //
        else {
            requireLogin();
        }
    }

    class CompanyLists {
        constructor() {
            this.lists = [];
            this.folders = new Folders();
        }

        newCompanyList(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName) {
            const companyList = new CompanyList(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName);
            this.lists.push(companyList);
            return companyList;
        }

        getRecentCompanyLists() {
            let method, url;
            const companyListsObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_recent_ml_lists";

            const getRecentCompanyListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.companies_lists.forEach(list => companyListsObject.newCompanyList(list.list_id, list.title, list.notes, list.return_count, list.created, list.edited, list.folder_id, list.version, list.trainingCompanies.include.length, list.trainingCompanies.exclude.length, list.folder_name));
                }
                companyListsObject.addListElementsToPage();
                companyListsObject.folders.getFolders();
            }

            const getRecentCompanyListsError = function () {
                companyListsObject.folders.getFolders();
            }

            coreFunctions.xhrHelper(method, url, getRecentCompanyListsSuccess, getRecentCompanyListsError);
        }

        addListElementsToPage() {
            if (this.lists.length > 0) {
                this.lists.forEach(list => list.addListElementToPage());
            } else {
                // No saved lists
                document.querySelector(".existingListsHolder[folder='recent']").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any company lists." }));
            }
        }

        editList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("editListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=editlist&listid=${form.elements.listID.value}`;

            const editListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.lists.find(list => list.listID == response.listID).editListLoad(response);
                } else {
                    listsObject.editListError(response);
                }
            }

            const editListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit company list."
                }
                listsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editListSuccess, editListError, input);
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditListInputError() {
            document.querySelector("#editListForm .input_error").innerHTML = "&nbsp;";
        }

        editListNotes(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("notesListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=notes&listid=${form.elements.listID.value}`;

            const notesListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesListForm textarea[name='notes']").value = response.notes;
                    listsObject.lists.find(list => list.listID == response.listID).notes = response.notes;

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    listsObject.editListError(response);
                }
            }

            const notesListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit company list."
                }
                listsObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesListSuccess, notesListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearNotesListInputError() {
            document.querySelector("#notesListForm .input_error").innerHTML = "&nbsp;";
        }

        moveList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("moveListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=move_ml_list&listid=${form.elements.listID.value}`;

            const moveListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    listsObject.lists.find(list => list.listID == response.listID).moveListLoad(response);
                } else {
                    listsObject.moveListError(response);
                }
            }

            const moveListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not move list."
                };
                listsObject.moveListError(response);
            }

            coreFunctions.xhrHelper(method, url, moveListSuccess, moveListError, input);

        }

        moveListError(response) {
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=sharelist&listid=${form.elements.listID.value}`;

            const shareListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareListLoad(response);
            }

            const shareListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareListSuccess, shareListError, input);

        }

        shareListLoad(response) {
            document.getElementById("shareListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareListButton"));
                coreFunctions.showStatusMessage("Share success", `The "${response.list_title}" list has been shared with user ${response.share_email}`);
            }
            document.querySelector("#shareListForm .input_error[field='email']").innerHTML = response.input_errors.email;
            document.querySelector("#shareListForm .input_error[field='general']").innerHTML = response.input_errors.general;
        }

        resetShareListInputErrors() {
            document.querySelector("#shareListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        copyList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=copy_ml_list&listid=${form.elements.listID.value}`;

            const copyListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyListLoad(response);
            }

            const copyListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyListSuccess, copyListError, input);

        }

        copyListLoad(response) {
            let copiedListDetails;
            document.getElementById("copyListButton").disabled = false;
            if (response.status == "success") {
                copiedListDetails = response.listDetails;
                this.newCompanyList(copiedListDetails.listID, copiedListDetails.title, '', copiedListDetails.returnCount, copiedListDetails.created, copiedListDetails.edited, copiedListDetails.folderID, copiedListDetails.version, copiedListDetails.trainingIncludeTotalCompanies, copiedListDetails.trainingExcludeTotalCompanies).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteCompanyList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/ml_list/ml_list_actions.php?action=delete_ml_list&listid=${form.elements.listID.value}`;

            const deleteListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteCompanyListLoad(response);
            }

            const deleteListError = function () {
                const response = {
                    status: "error",
                    title: "List delete error",
                    message: "Sorry, your list could not be deleted at this time."
                }
                listsObject.deleteCompanyListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteListSuccess, deleteListError, input);
        }

        deleteCompanyListLoad(response) {
            document.getElementById("deleteListButton").disabled = false;
            if (response.status == "success") {
                this.lists.find(list => list.listID == response.listID).deleteListControlElementFromPage();
            }
            coreFunctions.hideOverlay(document.getElementById("deleteListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    class CompanyList {
        constructor(listID, title, notes, returnCount, created, edited, folderID, version, trainingIncludeTotalCompanies, trainingExcludeTotalCompanies, folderName) {
            this.listID = listID;
            this.title = title;
            this.notes = notes;
            this.returnCount = returnCount;
            this.created = created;
            this.edited = edited;
            this.folderID = folderID;
            this.version = version;
            this.currentProductVersion = "2.0";
            this.trainingIncludeTotalCompanies = trainingIncludeTotalCompanies;
            this.trainingExcludeTotalCompanies = trainingExcludeTotalCompanies;
            this.folderName = folderName;
        }

        checkListBuiltWithCurrentVersion() {
            return this.version == this.currentProductVersion;
        }

        addListElementToPage(copiedList) {
            let existingList, actionsHolder, listDetailsElement, listBuiltWithCurrentVersion, listActionsControlLabel, accordianListMain;
            const listObject = this;

            listBuiltWithCurrentVersion = this.checkListBuiltWithCurrentVersion();

            existingList = coreFunctions.createElementHelper("li", { class: "existingList", list_id: this.listID });

            accordianListMain = existingList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            accordianListMain.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder"})).appendChild(coreFunctions.createElementHelper("button", { class: "actionControl extraDetailsButton", innerHTML: "&nbsp;" }, { click: function () { listObject.extraDetailsButtonClick(this) } }))

            listDetailsElement = accordianListMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder =  accordianListMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder actionsHolder" }));

            listDetailsElement.appendChild(coreFunctions.createElementHelper("a", { class: "existingListName", href: `${urlPath}/ml_list?list_id=${this.listID}${(listBuiltWithCurrentVersion) ? "" : "&legacylist=true"}`, innerHTML: `<span>${this.title}${(copiedList) ? " <strong>*New</strong>" : ""}${(listBuiltWithCurrentVersion) ? `<span class='formattedVersion'></span>` : ""}</span>` }));

            existingList.appendChild(this.addListExtraDetails());

            // Only add controls for lists made in the current version
            if (listBuiltWithCurrentVersion) {
                actionsHolder.appendChild(coreFunctions.createElementHelper("input", { class: "listActionsControl", type: "checkbox", id: `listActionsControl-${this.listID}` }, {change: function() {listObject.listActionsControlOnChange(this);}}));

                listActionsControlLabel = actionsHolder.appendChild(coreFunctions.createElementHelper("label", { class: "listActionsControlLabel", for: `listActionsControl-${this.listID}` }));

                listActionsControlLabel.appendChild(coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" }));

                listActionsControlLabel.appendChild(this.createListActionsControls());
            }

            if (copiedList) {
                document.querySelector(".existingListsHolder[folder='recent']").insertBefore(existingList, document.querySelector(".existingListsHolder[folder='recent']").firstElementChild.nextElementSibling)
            } else {
                document.querySelector(".existingListsHolder[folder='recent']").appendChild(existingList);
            }
        }

        listActionsControlOnChange(element) {
            let activeActionTab
            if (activeActionTab = document.querySelector(`.existingListsHolder input.listActionsControl:not(#${element.id}):checked`)) {
                activeActionTab.checked = false;
            }
        }

        createListActionsControls() {
            let actionsHolder;
            const listObject = this;

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit name</span>", class: "actionControl edit-list", title: "Edit list" }, { click: function () { listObject.updateEditListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Notes</span>", class: "actionControl list-notes", title: "Edit notes" }, { click: function () { listObject.updateNotesListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Make a copy</span>", title: "Copy list", class: "actionControl copy-list" }, { click: function () { listObject.copyListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Move</span>", title: "Move list", class: "actionControl move-list" }, { click: function () { listObject.moveListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Share</span>", title: "Share list", class: "actionControl share-list" }, { click: function () { listObject.shareListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Delete</span>", title: "Delete list", class: "actionControl delete-list" }, { click: function () { listObject.deleteCompanyListButtonClick() } }));

            return actionsHolder;
        }

        updateEditListOverlay() {
            // Hide previous input errors
            companyLists.clearEditListInputError();
            document.querySelector("#editListForm input[name='listID']").value = this.listID;
            document.querySelector("#editListForm input[name='title']").value = this.title;
            coreFunctions.showOverlay("editlist");
        }

        updateNotesListOverlay() {
            // Hide previous input errors
            companyLists.clearNotesListInputError();
            document.querySelector("#notesListForm input[name='listID']").value = this.listID;
            document.querySelector("#notesListForm textarea[name='notes']").value = this.notes;
            coreFunctions.showOverlay("noteslist");
        }

        editListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            this.title = response.listTitle;
            // Update title on select page with new text
            document.querySelector(`.existingList[list_id='${this.listID}'] .existingListName span`).innerHTML = this.title;
            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);

        }

        copyListControlAction() {
            document.getElementById("listToCopyTitle").innerHTML = this.title;
            document.querySelector("#copyListForm input[name='copyListTitle']").value = `${this.title} copy`;
            document.querySelector("#copyListForm input[name='listID']").value = this.listID;
            coreFunctions.showOverlay("copylist");
        }

        moveListControlAction() {
            document.querySelector("#moveListForm input[name='listID']").value = this.listID;
            // See if the folders list is active
            if (document.getElementById("moveListFolders").querySelector(`option[value='${this.folderID}']`)) {
                // Set to current value
                document.getElementById("moveListFolders").value = this.folderID;
            }
            // Otherwise set to the default all value
            else {
                document.getElementById("moveListFolders").value = "all";
            }
            // Add title and add to control box
            document.getElementById("listToMoveTitle").innerHTML = this.title;
            coreFunctions.showOverlay("movelist");
        }

        moveListLoad(response) {
            this.folderID = response.folderID;
            document.getElementById("moveListButton").disabled = false;
            coreFunctions.hideOverlay(document.getElementById("moveListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareListControlAction() {
            document.querySelector("#shareListForm input[name='shareUserEmail']").value = null;
            document.querySelector("#shareListForm input[name='listID']").value = this.listID;
            companyLists.resetShareListInputErrors();

            // Add title and add to control box
            document.getElementById("listToShareTitle").innerHTML = this.title;
            coreFunctions.showOverlay("sharelist");
        }

        deleteCompanyListButtonClick() {
            document.getElementById("companyListDeleteWarningTitle").innerHTML = `Confirm "${this.title}" deletion`;
            document.querySelector("#deleteListForm input[name='listID']").value = this.listID;
            document.querySelector("#deleteListForm input[name='title']").value = this.title;
            coreFunctions.showOverlay("deletelistpanel");
        }

        deleteListControlElementFromPage() {
            document.querySelector(".existingListsHolder[folder='recent']").removeChild(document.querySelector(`.existingList[list_id='${this.listID}']`));
        }

        addListExtraDetails() {
            let extraDetailsHolder = coreFunctions.createElementHelper("ul", { class: "extraDetailsHolder accordian-list-details" });

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Last edited</div><div class='field'>${moment(this.edited, "YYYY-MM-DD HH:mm:ss").format("HH:mm DD/MM/YY")}</div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Training set</div><div class='field'>Include: <span class='green'>${this.trainingIncludeTotalCompanies}</span> | Exclude: <span class='orange'>${this.trainingExcludeTotalCompanies}</span></div>` }));

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Folder</div><div class='field'><a class='folderLink' href='${(this.folderID) ? `${urlPath}/listsfolder?folder_id=${this.folderID}&folder_name=${this.folderName}` : `${urlPath}/listsfolder?folder_id=all`}' target='_blank'>${(this.folderName) ? this.folderName : "All company lists"}<a></div>` })); // Folder link

            return extraDetailsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }
    }

    class Folders {
        constructor() {
            this.folders = [];
        }

        getFolders() {
            let method, url;
            const foldersObject = this;

            method = "GET";
            url = "../api/lists/lists_actions.php?action=get_ml_list_folders";

            const getFoldersSuccess = function (responseText) {
                const response = JSON.parse(responseText)
                if (response.status == "success") {
                    response.folders.forEach(folder => foldersObject.newFolder(folder.folder_id, folder.folder_name));
                    foldersObject.addFoldersToPage();
                }
                document.getElementById("main").classList.remove("mainHidden");
            }

            const getFoldersError = function () {
                console.log("Error getting folders");
                document.getElementById("main").classList.remove("mainHidden");
            }

            coreFunctions.xhrHelper(method, url, getFoldersSuccess, getFoldersError);
        }

        newFolder(folderID, name) {
            const folder = new Folder(folderID, name);
            this.folders.push(folder);
            return folder;
        }

        addFoldersToPage() {
            this.folders.forEach((folder, index) => folder.addFolderToPage(index).addFolderToMoveListSelect());
        }

        folderSubgroupToggleOnClick(element) {
            element.querySelector(".iconRotate").classList.toggle("icon-rotate--rotated");
            document.getElementById("foldersPanelExpand").classList.toggle("panel-expand__expanded");
        }

        newFolderControlClick() {
            document.getElementById("newFolderTitle").value = null;
            coreFunctions.showOverlay("newfolder");
        }

        createNewFolder(form) {
            let input, method, url;
            const foldersObject = this;

            document.getElementById("newFolderSubmit").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = "../api/lists/lists_actions.php?action=new_ml_list_folder";

            const createNewFolderSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                foldersObject.newFolderLoad(response);
            }

            const createNewFolderError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not create new folder."
                }
                foldersObject.newFolderLoad(response);
            }

            coreFunctions.xhrHelper(method, url, createNewFolderSuccess, createNewFolderError, input);
        }

        newFolderLoad(response) {
            document.getElementById("newFolderSubmit").disabled = false;
            if (response.status == "success") {
                this.newFolder(response.folderID, response.folderName).addNewFolderToPage().addFolderToMoveListSelect().updateFolderOrdering();
            }
            coreFunctions.hideOverlay(document.getElementById("newFolderSubmit"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }
    }

    class Folder {
        constructor(folderID, name) {
            this.folderID = folderID;
            this.name = name;
            this.folderElementsInTopLevel = 6;
        }

        addFolderToPage(index) {
            let folderHolder;
            if (index < (this.folderElementsInTopLevel - 2)) {
                folderHolder = document.querySelector("#folderSelectHolder .topFolders");
                folderHolder.insertBefore(this.createNewFolderControl(), folderHolder.lastElementChild);
            } else {
                document.getElementById("folderSubgroup").classList.remove("hidden");
                document.getElementById("showAllFoldersHolder").classList.remove("hidden");
                folderHolder = document.querySelector("#folderSelectHolder .folderSubgroup");
                folderHolder.appendChild(this.createNewFolderControl());
            }
            return this;
        }

        addNewFolderToPage() {
            let folderHolder = document.querySelector("#folderSelectHolder .topFolders");
            folderHolder.insertBefore(this.createNewFolderControl(), folderHolder.firstElementChild.nextSibling);
            return this;
        }

        addFolderToMoveListSelect() {
            document.getElementById("moveListFolders").appendChild(coreFunctions.createElementHelper("option", { value: this.folderID, innerHTML: this.name }));
            return this;
        }

        updateFolderOrdering() {
            let currentLastFolderElementInTopLevel, folderSubgroup;
            if (this.totalFolderElementsInTopLevel() > this.folderElementsInTopLevel) {
                folderSubgroup = document.getElementById("folderSubgroup");
                currentLastFolderElementInTopLevel = document.querySelector("#folderSelectHolder .topFolders").lastElementChild.previousSibling;
                folderSubgroup.insertBefore(currentLastFolderElementInTopLevel, folderSubgroup.firstElementChild);
                document.getElementById("folderSubgroup").classList.remove("hidden");
                document.getElementById("showAllFoldersHolder").classList.remove("hidden");
            }
            return this;
        }

        totalFolderElementsInTopLevel() {
            return document.querySelector("#folderSelectHolder .topFolders").children.length;
        }

        createNewFolderControl() {
            let folderSelectFlex, folderSelect, folderSelectButton;

            folderSelectFlex = coreFunctions.createElementHelper("div", { class: "folderSelectFlex" });

            folderSelect = folderSelectFlex.appendChild(coreFunctions.createElementHelper("div", { class: "folderSelect" }));

            folderSelectButton = folderSelect.appendChild(coreFunctions.createElementHelper("a", { href: `${urlPath}/listsfolder?folder_id=${this.folderID}&folder_name=${this.name}`, class: "folderSelectButton", innerHTML: `<span class='folderName'>${this.name}</span>` }))

            return folderSelectFlex;
        }
    }

    const companyLists = new CompanyLists();

    return {
        pageBodyLoad: pageBodyLoad,
        companyLists: companyLists,
    }

}();
